<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { Inventory } from "@/services/westore/entities";
import moment from "moment";
import { Download } from "@/mixins/download";
import { channels } from "@/mixins/channels";
import WsTable from "../../../components/westoreTable/ws-table.vue";
import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";
import { localProductData } from "./local";
export default {
  mixins: [Download, channels],
  page: {
    title: "Inventory List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    WsTable,
    SkeletonLoader,
  },
  data() {
    return {
      title:this.$t("Product Details"),
      product_id: this.$route.params.product_id,
      product: {},
      filter: {
        orderId: null,
        type: null,
        date_from: null,
        date_to: null,
      },
      sortBy: "id",
      sortDesc: false,
      currentPage: 1,
      perPage: 20,
      paginateStart: 1,

      totalItems: 0,
      items: [],
      fields: [
        {
          key: "order_id",
          label: this.$t("Order ID"),
          sortable: true,
        },
        {
          key: "type",
          label:this.$t("Transaction Type"),
          sortable: true,
        },
        {
          key: "created_at",
          label:this.$t("Transaction Date"),
          sortable: true,
        },
        {
          key: "quantity",
          label:this.$t("QUANTITY"),
          sortable: true,
        },
        {
          key: "price",
          label: this.$t("Price"),
          sortable: true,
        },

        {
          key: "warehouse",
          label: this.$t("Warehouse"),
          sortable: true,
        },
      ],
      showContentLoader: true,
      showTableLoader: true,
    };
  },

  mounted() {
    this.fetchData();
    this.fetchTransactions();
  },

  methods: {
    async fetchData() {
      this.showContentLoader = true;

      try {
        if (this.$route.params.product_id == 1111) {
          this.product = localProductData;
          this.items = this.product.transactions;
        } else {
          let { data } = await Inventory.getOne(this.$route.params.product_id);

          this.product = data;
        }
      } catch (error) {
        this.$toast.error("Something went wrong,please try again");
      } finally {
        this.showContentLoader = false;
      }
    },
    async fetchTransactions() {
      this.showTableLoader = true;
      try {
        const requestParams = {
          ...this.filter,
          page: this.currentPage,
          per_page: this.perPage,
        };
        let { data, total } = await Inventory.getTransactions(
          requestParams,
          this.product_id
        );

        this.items = data;

        this.totalItems = total;
        this.showContentLoader = false;
      } catch (error) {
        this.$toast.error("Something went wrong,please try again");
      } finally {
        this.showTableLoader = false;
      }
    },
    applyFilter() {
      this.currentPage = 1;
      const { orderId, type, date_from, date_to } = this.filter;
      if (!orderId && !type && !date_from && !date_to) {
        return this.$toast.error("Please determine a filtration method first");
      }
      if (type === "All") {
        this.filter.type = null;
      }
      this.fetchTransactions();
    },
    resetFilter() {
      this.currentPage = 1;
      this.filter = {
        orderId: null,
        date_from: null,
        date_to: null,
        type: null,
      };
      this.fetchTransactions();
    },
    convertDate: function (timestampValue) {
      return moment.unix(timestampValue).format("DD/MM/YYYY");
    },
    ToTimeStamp(date) {
      return Date.parse(date) / 1000;
    },
    async exportSheet(extension) {
      const data = await Inventory.blobResponse().exportOne(
        { type: extension },
        this.product.id
      );

      const type = Inventory.getHeader("content-type");
      const filename = `inventory${new Date().getTime()}.${extension}`;
      this.download(data, type, filename);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"></PageHeader>
    <v-row v-if="showContentLoader">
      <v-col v-for="n in 2" :key="n" cols="12" md="6">
        <SkeletonLoader type="image" />
      </v-col>
    </v-row>
    <div class="row" v-else>
      <div class="col-md-6">
        <div class="h-100 shadow">
          <v-card class="mx-auto h-100 pt-1" rounded="3" elevation="0">
            <v-list-item three-line>
              <v-list-item-avatar rounded="3" width="150" height="150">
                <img src="../../../assets/images/placeholder.png" />
              </v-list-item-avatar>
              <v-list-item-content class="pb-15 pt-6">
                <v-list-item-title
                  class="text-h6 text-info font-weight-bold mb-2"
                >
                  {{$t('PRODUCT NAME')}}
                </v-list-item-title>
                <v-list-item-subtitle class="text-primary"
                  >{{ product.name }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-muted mt-1 mb-1"
                  >{{$t('SKU Code')}}
                  <span class="text-primary">{{ product.sku }}</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-muted mt-1"
                  > {{$t('Category')}}<span class="text-primary">{{
                    product.category
                  }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </div>
      </div>
      <div class="col-md-6">
        <div class="shadow">
          <v-card rounded="3" elevation="0" class="pt-3">
            <v-card-text>
              <div class="ml-8 mb-2 text-h6 text-info font-weight-bold">
                {{$t('Summary')}}
              </div>

              <v-timeline align-top dense class="pt-0">
                <v-timeline-item small color="secondary">
                  <div>
                    <div class="font-weight-normal">
                      <strong class="text-muted"> : {{$t('Total')}} </strong>
                      <span class="text-primary">{{
                        product.quantity_summary
                      }}</span>
                    </div>
                  </div>
                </v-timeline-item>
                <v-timeline-item small color="secondary">
                  <div>
                    <div class="font-weight-normal">
                      <strong> : {{$t('Sellable Quantity')}}</strong
                      ><span class="text-primary">{{
                        product.inventory_quantity
                      }}</span>
                    </div>
                  </div>
                </v-timeline-item>
                <v-timeline-item small color="secondary">
                  <div>
                    <div class="font-weight-normal">
                      <strong> : {{$t('Reserved Quantity')}} </strong>
                      <span class="text-primary">{{
                        product.booked_quantity
                      }}</span>
                    </div>
                  </div>
                </v-timeline-item>
                <v-timeline-item small color="secondary">
                  <div>
                    <div class="font-weight-normal">
                      <strong> : {{$t('Unavailable')}} </strong>
                      <span class="text-primary">{{
                        product.blocked_quantity
                      }}</span>
                    </div>
                  </div>
                </v-timeline-item>
                <v-timeline-item
                  small
                  color="secondary"
                  :class="!product.vendor && 'pb-0'"
                >
                  <div>
                    <div class="font-weight-normal d-flex align-center">
                      <div :class="isRtl ? 'ml-3':'mr-3'">
                        <strong> : {{$t('Source')}}</strong>
                      </div>
                      <div>
                        <v-img
                          class="mx-auto"
                          :src="detectChannel(product.marketplace)"
                          height="25"
                          :width="
                            product.marketplace === 'woocommerce' ||
                            product.marketplace === 'WeStore Api' ||
                            !product.marketplace
                              ? 110
                              : 28
                          "
                        />
                      </div>
                    </div>
                  </div>
                </v-timeline-item>
                <v-timeline-item
                  v-if="product.vendor"
                  small
                  color="secondary"
                  class="pb-0"
                >
                  <div>
                    <div class="font-weight-normal">
                      <strong>  {{$t('Supplier ')}} </strong>
                      <span class="text-primary"> {{ product.vendor }}</span>
                    </div>
                  </div>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="row mb-5">
              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{$t("Date From")}}</label>
                  <b-form-input
                    v-model="filter.date_from"
                    type="date"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{$t("Date To")}}</label>
                  <b-form-input
                    v-model="filter.date_to"
                    type="date"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{$t('Order ID')}}</label>
                  <input
                    id="transactionId"
                    v-model="filter.orderId"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{$t('Type')}}</label>
                  <select
                    class="form-control select2-search-disable"
                    v-model="filter.type"
                  >
                    <option class="m-2" value="All">{{$t('All')}}</option>
                    <option class="m-2" value="Inbound">{{$t('Inbound')}}</option>
                    <option class="m-2" value="Order">{{$t('Order')}}</option>
                    <option class="m-2" value="Return">{{$t('Return')}}</option>
                  </select>
                </div>
              </div>

              <div class="col-xl col-sm-6 align-self-end pb-3">
                <div class="mt-0 d-flex justify-end align-center">
                  <div :class="isRtl ? 'ml-auto':'mr-auto'">
                    <v-btn color="primary_1" dark @click="applyFilter">
                      <i class="fa fa-search"></i>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      color="warning"
                      dark
                      @click="resetFilter"
                    >
                      <i class="fa fa-trash"></i>
                    </v-btn>
                  </div>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      >
                        {{$t('Export')}}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.prevent="exportSheet('pdf')">
                        <v-list-item-title>
                          <i class="fa fa-file-pdf mr-2"></i>
                          Pdf</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item @click.prevent="exportSheet('xlsx')">
                        <v-list-item-title
                          ><i class="fa fa-file-excel mr-2"></i
                          >Excel</v-list-item-title
                        >
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
            <SkeletonLoader v-if="showTableLoader" type="table" />
            <div v-else>
              <WsTable
                :items="items"
                :totalItems="totalItems"
                :fields="fields"
                :paginateStart="paginateStart"
              />
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalItems"
                        :per-page="perPage"
                        :first-text="this.$t('First')"
                        :prev-text="this.$t('Prev')"
                        :next-text="this.$t('Next')"
                        :last-text="this.$t('Last')"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
.p-item + .p-item:before {
  content: ", ";
}
.v-timeline:before {
  height: 89%;
  top: 10px;
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before,
.v-application--is-rtl .v-timeline--reverse.v-timeline--dense:before {
  right: auto;
  left: 38px;
}
.v-timeline-item__divider {
  position: relative;
  min-width: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: st;
}
.v-timeline-item {
  padding-bottom: 8px;
  justify-content: left;
  margin-inline-start: 15px;
}
.v-timeline-item__dot {
  box-shadow: none;
}
.v-timeline-item__dot--small .v-timeline-item__inner-dot {
  height: 15px;
  margin: 3px;
  width: 15px;
}
.v-timeline-item__dot--small {
  height: 25px;
  left: calc(50% - 12px);
  width: 20.5px;
}
.theme--light.v-timeline .v-timeline-item__dot {
  background: none;
}
</style>
